import { render } from "./ResellerCompanies.vue?vue&type=template&id=43d6bca7&scoped=true"
import script from "./ResellerCompanies.vue?vue&type=script&lang=js"
export * from "./ResellerCompanies.vue?vue&type=script&lang=js"

import "./ResellerCompanies.vue?vue&type=style&index=0&id=43d6bca7&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d6bca7"]])

export default __exports__